window.Banner = new (function () {

    const Swal = require('./plugins/sweetalert2');

    var that = this;
    var inputBannerMobileES = $('#banner_mobile_es');
    var inputBannerDeskES = $('#banner_desktop_es');
    var inputBannerMobileEN = $('#banner_mobile_en');
    var inputBannerDeskEN = $('#banner_desktop_en');
    var inputFloatES = $('#float_element_en');
    var inputFloatEN = $('#float_element_es');

    var onDragEnter = function(event) {
            event.preventDefault();
            $(this).addClass("dragover");
        },

        onDragOver = function(event) {
            event.preventDefault();
            if(!$(this).hasClass("dragover"))
                $(this).addClass("dragover");
        },

        onDragLeave = function(event) {
            event.preventDefault();
            $(this).removeClass("dragover");
        },

        onDrop = function(event) {
            event.preventDefault();
            $(this).removeClass("dragover");

            var device = $(this).data('device');
            var files = event.originalEvent.dataTransfer.files;
            that.bannerPreview(files, device);
        };

    this.init = function () {

        //active dropzone for qr
        $('.dropZone').on("dragenter", onDragEnter)
            .on("dragover", onDragOver)
            .on("dragleave", onDragLeave)
            .on("drop", onDrop);

        //$('.box').on('click', that.callInputFile);

        $("input[type='file']").on('change', function (event) {
            var device = $(this).data('device');
            var files = event.target.files;
            that.bannerPreview(files, device);
        });

        //change to visible or invisible banner
        $('.disable-banner').on('click', that.changeVisible);

        try {
            $('#sortable').sortable();
            $('#sortable').disableSelection();
            $( "#sortable" ).on( "sortstop", that.updatePositions );
        } catch (e) {

        }

    };

    /**
     * Load image preview
     * @param files
     * @param device
     */
    this.bannerPreview = function (files, device) {

        var elementID = device;

        //file exist
        if (files && files[0]) {
            var reader = new FileReader();

            //load src
            reader.onload = function(e) {
                $('#' + elementID).attr('src', e.target.result);
                $('#' + elementID).removeClass('d-none');

                $('.box.' + device).addClass('loaded');
            }

            reader.readAsDataURL(files[0]); // convert to base64 string

            //pass to input file
            //(device == 'mobile') ? $(inputBannerMobile).val(files[0]) : $(inputBannerDesk).val(files[0]);
        }

    };

    /**
     * Trigger to input file
     */
    this.callInputFile = function () {

        var device = $(this).data('device');

        if(device == 'mobile_es') {
            $(inputBannerMobileES).trigger('click');
        } else if(device == 'mobile_en') {
            $(inputBannerMobileEN).trigger('click');
        } else if(device == 'desktop_es') {
            $(inputBannerDeskES).trigger('click');
        } else if(device == 'desktop_en') {
            $(inputBannerDeskEN).trigger('click');
        } else if(device == 'float_es') {
            $(inputFloatES).trigger('click');
        } else if(device == 'float_en') {
            $(inputFloatEN).trigger('click');
        }

    };

    /**
     * change banner visible / invisible
     */
    this.changeVisible = function () {

        //wait alert
        Swal.fire({
            title: 'Por favor, espere!',
            onBeforeOpen: () => {
                Swal.showLoading()
            }
        });

        var bannerID = $(this).data('bannerid');
        var theButton = $(this);

        //ajax settings
        var settings = {
            url: changeBannerVisibleRoute,
            method: "POST",
            data: {
                '_token': $(document).find('meta[name="csrf-token"]').attr("content"),
                'banner_id': bannerID,
            }
        }

        //ajax call
        $.ajax(settings).done(function (response) {
            var message = 'Banner cambió a visible en el sitio web.';
            $(theButton).html('Ocultar');
            $('.banner-'+bannerID).removeClass('banner-no-visible');

            try {
                $(theButton).tooltip('hide')
                    .attr('data-original-title', 'Clic para ocultar este banner')
                    .tooltip('fixTitle')
                    .tooltip('show');
            } catch (e) {

            }


            if(response == 'invisible') {
                message = 'Banner cambió a no visible en el sitio web.';
                $(theButton).html('Hacer visible');
                $('.banner-'+bannerID).addClass('banner-no-visible');
                try {
                    $(theButton).tooltip('hide')
                        .attr('data-original-title', 'Clic para hacer visible este banner')
                        .tooltip('fixTitle')
                        .tooltip('show');
                } catch (e) {

                }
            }

            //ajax call fail
            Swal.fire(
                'Cambio exitoso',
                 message,
                'success'
            );


        }).fail(function (xhr, status, error) {

            //ajax call fail
            Swal.fire(
                'Ocurrio un error',
                error,
                'error'
            );
        });

    };

    /**
     * Update qr positions
     */
    this.updatePositions = function (event, ui) {
        var data = $(this).sortable( "toArray" );

        //wait alert
        Swal.fire({
            title: 'Por favor, espere!',
            onBeforeOpen: () => {
                Swal.showLoading()
            }
        });

        //ajax settings
        var settings = {
            url: updateBannerPositionRoute,
            method: "POST",
            data: {
                '_token': $(document).find('meta[name="csrf-token"]').attr("content"),
                'positions': data,
            }
        }

        //ajax call
        $.ajax(settings).done(function (response) {

            //ajax call fail
            Swal.fire(
                'Cambio exitoso',
                'La nueva posición del banner ha quedado guardada.',
                'success'
            );


        }).fail(function (xhr, status, error) {

            //ajax call fail
            Swal.fire(
                'Ocurrio un error',
                error,
                'error'
            );
        });

    };


})();
